import { DEEPLINK_SCHEME } from './deeplink-scheme';

export function buildLeaderboardDeeplink(): string {
  return `${DEEPLINK_SCHEME}leaderboard`;
}
